import { Box, styled } from "@mui/material";
import {
  computeArrowShadow,
  computeLeft,
  computeMargin,
  computeTop,
  getTranslate,
  hasCorrectPosition
} from "./utils.js";
const propsToNotForward = /* @__PURE__ */ new Set(["placement", "size", "popperRect", "referenceRect"]);
const Arrow = styled(Box, {
  skipSx: true,
  shouldForwardProp: (prop) => !propsToNotForward.has(prop.toString())
})((props) => {
  const {
    size,
    popperRect,
    placement,
    referenceRect,
    theme: {
      vars: { palette, overlays }
    }
  } = props;
  const translate = getTranslate(placement, referenceRect, popperRect);
  const correctPosition = hasCorrectPosition(placement, referenceRect, popperRect);
  return {
    position: "relative",
    margin: computeMargin(size, placement),
    opacity: correctPosition ? 1 : 0,
    "&::after, &::before": {
      content: '""',
      display: "block",
      position: "absolute",
      width: size,
      height: size,
      top: computeTop(size, placement),
      transform: `${translate} rotate(45deg)`,
      left: computeLeft(size, placement)
    },
    "&::after": {
      backgroundColor: palette.background.paper,
      backgroundImage: overlays[4],
      zIndex: 4
    },
    "&::before": {
      backgroundColor: "transparent",
      boxShadow: computeArrowShadow(placement),
      zIndex: -1
    }
  };
});
export {
  Arrow
};
//# sourceMappingURL=Arrow.js.map
